var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-5"},[_c('all-rally-rounds',{attrs:{"showHeading":false,"linkToEditPage":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }